import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TK2UserLookupDM from './TK2UserLookupDM'
import TCalculationModelDM from './TCalculationModelDM'

/**
 * Konfigurace pro kalkulace
 */
export default class TProductCostingConfigurationDM extends Data {
	public static className = 'TProductCostingConfigurationDM'
	public static primaryKey = 'Id'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	public static isHeader = true

	/**
	 * Blokováno
	 */
	IsBlockedRecord?: string

	/**
	 * Právo na záznam
	 */
	RightGroupId?: number

	/**
	 * Časové razítko
	 */
	TimeStamp?: string

	/**
	 * Změněno
	 */
	ChangedOn?: Date

	/**
	 * Vytvořeno
	 */
	CreatedOn?: Date

	/**
	 * Kalkulační dávka
	 */
	Quantity?: number

	/**
	 * Ukládat sumace položek
	 */
	SaveSumItems?: string

	/**
	 * Ukládat strom
	 */
	SaveTree?: string

	/**
	 * Agregační pole 5.
	 */
	AggregationField5?: string

	/**
	 * Agregační pole 4.
	 */
	AggregationField4?: string

	/**
	 * Agregační pole 3.
	 */
	AggregationField3?: string

	/**
	 * Agregační pole 2.
	 */
	AggregationField2?: string

	/**
	 * Agregační pole 1.
	 */
	AggregationField1?: string

	/**
	 * Popis
	 */
	Description?: string

	/**
	 * Zkratka
	 */
	Abbr?: string

	/**
	 * Číslo
	 */
	Id?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Právo na záznam
	 */
	RightGroupIdCalc?: number

	/**
	 * Změnil
	 */
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM

	/**
	 * Vytvořil
	 */
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM

	/**
	 * KV hmotnostní
	 */
	@Type(() => TCalculationModelDM)
	WeightCalculationModelId?: TCalculationModelDM

	/**
	 * KV plánovaný
	 */
	@Type(() => TCalculationModelDM)
	PriceCalculationModelId?: TCalculationModelDM

	/**
	 * Změna skupiny práv
	 */
	public ChangeGroupRightCOMMAND() {
		return this.executeCommand('ChangeGroupRightCOMMAND')
	}

	/**
	 * Změna skupiny práv
	 */
	public BulkChangeGroupRightCOMMAND() {
		return this.executeCommand('BulkChangeGroupRightCOMMAND')
	}

	/**
	 * Aktualizace počítaných polí
	 */
	public BulkUpdateCalcFieldsCOMMAND() {
		return this.executeCommand('BulkUpdateCalcFieldsCOMMAND')
	}

	/**
	 * Kontrola legislativy
	 */
	public SwitchOffLegislationValidationCOMMAND() {
		return this.executeCommand('SwitchOffLegislationValidationCOMMAND')
	}
}